import data from './data.json';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return data;
}